import { ViewMode } from 'components/MediaInput/MultimediaPlugin/types';
import { FC } from 'react';
import { GridView } from './GridView';
import { ListView } from './ListView';
import { useStyles } from './styles';
import { MultimediaListProps } from './types';

export const MultimediaList: FC<MultimediaListProps> = ({
  viewMode,
  ...restMultimediaListProps
}) => {
  const classes = useStyles({ isDisabled: restMultimediaListProps.isDisabled });
  return (
    <div className={classes.wrapper}>
      {viewMode === ViewMode.LIST ? (
        <ListView {...restMultimediaListProps} viewMode={viewMode} />
      ) : (
        <GridView {...restMultimediaListProps} viewMode={viewMode} />
      )}
    </div>
  );
};
